import {SEARCH_RESULTS_DATE_MOMENT_FORMAT, REQ_DAYS_FORWARD, MON_FORWARD_BACK,
     CHK_OUT_AVAIL_MONS, DEFAULT_LANG} from './constants';

import moment from 'moment';

export const fromToNoChkIn=()=>{
    return {
        fromDate: moment(),
        toDate: moment().add(REQ_DAYS_FORWARD, 'day')
    }
}

export const fromToWChkIn=(chkIn)=>{
    var fromDate = moment(chkIn).add(-MON_FORWARD_BACK, 'month');
    var toDate = moment(chkIn).add(MON_FORWARD_BACK, 'month');
    fromDate = moment()>fromDate? moment(): fromDate;
    return {
        fromDate: fromDate,
        toDate: toDate
    }
}

export const fromToChkOutAvail=(chkIn)=>{
    var fromDate = moment(chkIn);
    var toDate = moment(chkIn).add(CHK_OUT_AVAIL_MONS, 'month')
    return {
        fromDate: fromDate,
        toDate: toDate
    }
}

export const fromToDaysFor=(chkIn)=>{
    var fromDate = moment(chkIn);
    var toDate = moment(chkIn).add(REQ_DAYS_FORWARD, 'day')
    return {
        fromDate: fromDate,
        toDate: toDate
    }
}


export const dateTimeToMoment =(dateTime) =>{
    return moment(parseInt(dateTime.replace(/\/Date\((\d+)\)\//gi, "$1")) + 43200000);
}

export const getInitStateFromSession =()=>{
    if (typeof window.sessionSearchData!='undefined'){
        if (typeof window.sessionSearchDataJson=='undefined'){
            window.sessionSearchDataJson=JSON.parse(sessionSearchData);
        }
        return {
            dates: {
                CheckinDate:moment(sessionSearchDataJson.CheckIn,SEARCH_RESULTS_DATE_MOMENT_FORMAT),
                CheckoutDate:moment(sessionSearchDataJson.CheckOut,SEARCH_RESULTS_DATE_MOMENT_FORMAT)
            },
            pax: sessionSearchDataJson.Pax,
            selectedHotelId: sessionSearchDataJson.SelectedHotelID,
            selectedRegionId: sessionSearchDataJson.SelectedRegionID
        }
    }else return null;
}

export const getTempCheckinDate= ()=>{
    return moment().add(2,'month');
}

export const mapLocale= (locale) =>{
    switch (locale) {
        case 'heb':
            return 'he-il';
        case 'eng':
            return 'en-us';
        default:
            return 'en-us';
    }
}

export const extendedSearchParams =(data, mainKey,arr=false, obj=false)=> Object.keys(data).map((key) => {
  if (Array.isArray(data[key])){
    var tt=extendedSearchParams(data[key],key, true);
    return tt;
  }else if (typeof data[key] == 'object') {
    return extendedSearchParams(data[key], arr? mainKey+'['+key+']': key, false, true);
  }
  return encodeURIComponent(arr?mainKey+'['+key+']': (obj?mainKey+'.'+key: key)) + '=' + encodeURIComponent(data[key]);
}).join('&');

export const  getUrlVars = ()=> {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

export const getLangFromUrl = () =>{
    let params = getUrlVars();
    if (params.lang)
        return params.lang.toLowerCase();
    else return DEFAULT_LANG;
}

export const mapDirection =(lang) =>{
    switch (lang) {
        case 'heb':
            return 'right';
        default:
            return 'left';
    }
}


// WEBPACK FOOTER //
// ./src/tools/inits.js